import React from "react";
import './footer.css';
const Footer = () => {
    return (
        <footer className="footer">
             2023 Andi Scarola
        </footer>
    );
}

export default Footer